import { ADVANCED_BACKGROUND_COLORS, BACKGROUND_COLORS } from '@hotjar/feedback';
import { useTranslation } from '@hotjar/translations';
import { ColorPaletteGate } from './ColorPaletteGate';
import type { ColorPaletteProps } from './ColorPalette';

type BackgroundColorPaletteProps = Pick<ColorPaletteProps, 'value' | 'onChange' | 'onPreviewColor'>;

export const BackgroundColorPalette = (props: BackgroundColorPaletteProps): JSX.Element => {
  const { t } = useTranslation('feedback', {
    keyPrefix: 'wizard.section.appearance.background-color',
  });
  return (
    <ColorPaletteGate
      label={t('label')}
      defaultColor={BACKGROUND_COLORS[0].fill}
      baseColors={BACKGROUND_COLORS}
      advancedColors={ADVANCED_BACKGROUND_COLORS}
      {...props}
    />
  );
};
